var _rect, _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimumAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#E6FBF5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 7,
    rx: 5.5,
    ry: 2.5,
    stroke: "#11B981",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7V11C6.5 12.4 9 13.5 12 13.5C15 13.5 17.5 12.4 17.5 11V7",
    stroke: "#11B981",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11V15C6.5 16.4 9 17.5 12 17.5C15 17.5 17.5 16.4 17.5 15V11",
    stroke: "#11B981",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimumAmount);
export default __webpack_public_path__ + "static/media/minimum-amount.207dd37b28b4721106299165b31ef565.svg";
export { ForwardRef as ReactComponent };